import { ChangeDetectionStrategy, Component, inject, OnInit, Renderer2 } from '@angular/core';
import { AppStorage } from '@app/common/services/data-api/app-storage.service';
import { PxdGridComponent } from '@app/shared/kendoui/grid/components/pxd-grid/pxd-grid.component';
import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';
import { isChildOf } from '@app/shared/utilities/javascript-utilities';
import { columns } from './columns';
import { FormationTopGridService } from './formation-top-grid.service';

@Component({
  selector: 'app-formation-top',
  templateUrl: './formation-top.component.html',
  styleUrls: ['./formation-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PxdGridComponent,
  ],
})
export class FormationTopComponent implements OnInit {
  public gridSvc = inject(FormationTopGridService);
  private appStorage = inject(AppStorage);
  private renderer = inject(Renderer2);


  public data: any = this.gridSvc.viewData;
  public columns: PxdColumns[] = columns;
  public canEdit: boolean;
  public columnSettingsKey: string = 'targetFormationsColumns';

  public gridConfig = {
    selectRow: true,
    state: this.gridSvc.gridState,
    selectedKeys: this.gridSvc.selectedKeys,
    kendoGridSelectBy: 'FormationTopId',
    service: this.gridSvc,
    canCreateNewRow: true
  };

  ngOnInit() {
    this.appStorage.knownEvents.assetTeamSelected.subscribe(event => {
      if (event && event.AssetTeamId !== this.gridSvc.currentAssetTeamId) {
        this.gridSvc.currentAssetTeamId = event.AssetTeamId;
        this.gridSvc.loadAssets();
      }
    });

    this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'k-grid-content') && !isChildOf(target, 'k-grid-toolbar')) {
          this.gridSvc.saveClick();
        }
      });
  }
}